import { useTranslation } from 'react-i18next'

import type { HTMLChakraProps } from '@enechain/ecloud-designsystem'
import {
  Box,
  MenuSeparator,
  MenuItem as RawMenuItem,
  Tooltip,
} from '@enechain/ecloud-designsystem'

import type { IntradayBulkDelete } from '~/pages/IntradayBidding/hooks/useIntradayBulkDelete'

/**
 * chakra v3 の `MenuItemProps` は本プロジェクトの型解決で collapse するため、 v3 本来の
 * prop シグネチャへ cast して復元する (`IntradayBulkWithdrawMenuItem` と同じ)。
 */
const MenuItem = RawMenuItem as React.FC<
  HTMLChakraProps<'div'> & {
    value: string
    closeOnSelect?: boolean
    onSelect?: () => void
  }
>

/** ⋯メニューでこの項目を見分ける値 (強調中かの判定にも使う)。 */
export const INTRADAY_BULK_DELETE_MENU_VALUE = 'bulk-delete'

type Props = {
  bulkDelete: Pick<IntradayBulkDelete, 'selectable' | 'tooltip' | 'open'>
  /** メニューで強調中か (ホバー・矢印キーのどちらでも true)。 強調中に押せない理由を出す。 */
  highlighted: boolean
}

/**
 * 入札一覧の操作行の ⋯メニューの「入札を全削除」 (AC-BIN-138、 design `intraday.html` の
 * `#intraday-bid-clear-all`)。 破壊的操作なので区切り線で他の項目から隔て、 文字を警告色にする。
 *
 * 選べない時は `disabled` でなく `aria-disabled` にし、 理由のツールチップは項目の内側に置く
 * (`IntradayBulkWithdrawMenuItem` と同じ。 キーボードでも理由に届き、 menu が矢印キーで項目を
 * 見つけられる)。
 */
export const IntradayBulkDeleteMenuItem = ({
  bulkDelete,
  highlighted,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const { selectable, tooltip, open } = bulkDelete
  return (
    <>
      <MenuSeparator />
      <MenuItem
        color="Text.negativeHigh"
        aria-disabled={selectable ? undefined : true}
        closeOnSelect={selectable}
        onSelect={selectable ? open : undefined}
        value={INTRADAY_BULK_DELETE_MENU_VALUE}
      >
        <Tooltip
          content={tooltip ?? ''}
          isHidden={tooltip === undefined || tooltip === ''}
          open={highlighted}
        >
          <Box as="span">{t('page:biddingIntraday.bulkDelete.menu.title')}</Box>
        </Tooltip>
      </MenuItem>
    </>
  )
}
